import { UPDATE_VIEW_PORT } from "./types"

export const updateViewPort = (viewport) => {
    return {
        type: UPDATE_VIEW_PORT,
        payload: viewport
    }
}